/** Languages supported by Sage STT + LLM prompts (must match interview_agent). */
export const SAGE_LANGUAGES = [
  'English',
  'Arabic',
  'French',
  'Spanish',
  'Urdu',
];

export const DEFAULT_SAGE_LANGUAGE = 'English';

export function normalizeSageLanguage(value) {
  const raw = String(value || '').trim();
  if (!raw) return DEFAULT_SAGE_LANGUAGE;
  const hit = SAGE_LANGUAGES.find(
    (l) => l.toLowerCase() === raw.toLowerCase()
  );
  return hit || DEFAULT_SAGE_LANGUAGE;
}
